import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotGridSection from './components/HotGridSection';
import ChannelMatrixSection from './components/ChannelMatrixSection';
import AboutSection from './components/AboutSection';
import ReviewsSection from './components/ReviewsSection';
import LatestSection from './components/LatestSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotGridSection />
        <ChannelMatrixSection />
        <AboutSection />
        <ReviewsSection />
        <LatestSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}